@if (article?.urlSlug) {
    <app-link
        class="flex w-full max-w-sm flex-auto flex-col text-darkgrey"
        link="/knowledge/{{ article?.urlSlug }}"
        [additionalClasses]="[
            'flex flex-col flex-auto items-stretch justify-stretch',
        ]"
        (mouseenter)="preloadArticle()"
        (touchstart)="preloadArticle()"
        [title]="article?.shortTitle">
        <article
            class="flex w-full flex-auto flex-col items-stretch rounded-fa text-darkgrey shadow-far transition duration-200 ease-in-out hover:shadow-md-far">
            <div class="aspect-h-9 aspect-w-16 overflow-hidden rounded-t-fa">
                <app-lazy-asset
                    [lazy]="lazy"
                    [configuration]="imageConfiguration"
                    [additionalClasses]="['rounded-t-fa']"></app-lazy-asset>
            </div>
            <div class="flex flex-col p-4 pb-6 md:px-6">
                <span class="block flex-grow pb-4 font-bold">{{
                    article?.shortTitle
                }}</span>
                <p class="line-clamp-2 text-sm text-deemphasized">
                    {{ article?.description }}
                </p>
            </div>
        </article>
    </app-link>
}
